// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"354":"component---src-pages-auth-validate-account-tsx","869":"styles","975":"component---src-templates-default-tsx"}[chunkId] + "-" + {"354":"5c9b7698b467f980a4b0","869":"7880f47251e670f57e9e","975":"b441e5e2cf93660d11a4"}[chunkId] + ".js";
};